import { Module } from "wrapper6";
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";

var $ = jQuery;

export default class ScrollToElements extends Module {

	ready() {

        new ScrollTo( document.querySelector('.mc4wp-alert'), 'page-template-newsletter' );
    }
}

class ScrollTo {

    constructor(el, bodyClass) {

        if (el && hasClass(document.body, bodyClass)) {

            let cls = el.className;
            cls = cls.replace(' ', '.');

            $('html, body').animate({ 
                scrollTop: $('.'+cls).offset().top - 150
            }, 1000);
        }
    }
}